export { TextHeading } from './TextHeading';
